import React from "react";
import { People } from "react-bootstrap-icons";

const About = () => {
  return (
    <section className="about-section py-5" id="about">
      <div className="container text-center">

        {/* Badge */}
        <span className="badge rounded-pill about-badge mb-3 px-4 py-2">
          About Us
        </span>

        {/* Title */}
        <h2 className="fw-bold display-5 mb-4">Our Story</h2>

        {/* Description */}
        <p className="lead about-desc mx-auto mb-5">
          Founded by seasoned industry professionals, 5 Helms Consulting emerged from a vision
          to revolutionize technology consulting. With over 20 years of collective
          experience, we bridge the gap between cutting-edge technology and business
          success, delivering solutions that transform operational capabilities.
        </p>

        {/* Card */}
        <div className="about-card mx-auto p-4 p-lg-5 text-start">
          <div className="d-flex align-items-start gap-4">
            
            {/* Icon */}
            <div className="icon-box d-flex align-items-center justify-content-center">
              <People size={32} />
            </div>

            {/* Content */}
            <div>
              <h4 className="fw-bold mb-3">
                Empowering Businesses Through Intelligent Workforce Management
              </h4>
              <p className="mb-0 about-card-text">
                At 5 Helms Consulting, we specialize in workforce management excellence.
                Our expertise spans strategic implementation, workforce optimization
                strategies, advanced insight generation, and transformative outcomes
                that drive real business value.
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
